<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [asyncSubmission]="true"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'leveringsgegevens',
  }"
>
  <ng-template #content>
    <div class="row mb-2">
      <div class="col-12 fw-bold">{{ orderContent().supplyAddressTitle }}</div>
      <div class="col-12">
        @if (supplyAddress(); as supplyAddress) {
          <p class="d-flex align-items-center mb-0">
            <wl-supply-address
              [supplyAddress]="supplyAddress"
              wlCSMask
            ></wl-supply-address>
            @if (orderContent().showChangeSupplyAddressLink) {
              <button
                class="btn btn-link m-0 p-0 ms-1 text-dark"
                (click)="changeSupplyAddressClick($event)"
              >
                {{ orderContent().changeSupplyAddressLinkText }}
              </button>
            }
          </p>
        }
      </div>
    </div>

    @if (orderContent().enableBusinessFields) {
      <div class="row mb-2">
        <wl-checkbox
          [rendering]="rendering()"
          stepName="leveringsgegevens"
          [step]="stepNumber()"
          fieldName="gebruik als correspondentieadres"
          [formsControl]="controls().useAsCorrespondenceAddress"
          [label]="orderContent().correspondenceAddressLabel"
        >
        </wl-checkbox>
      </div>
      @if (!formState().value.useAsCorrespondenceAddress) {
        <div>
          <p class="h6">{{ orderContent().correspondenceAddressTitle }}</p>
          <div class="row mb-2">
            <div class="row mb-2">
              <!-- Postal code -->
              <div class="col-6 col-lg-3">
                <wl-text
                  [rendering]="rendering()"
                  [step]="stepNumber()"
                  stepName="leveringsgegevens"
                  fieldName="postcode correspondentieadres"
                  [sendValue]="false"
                  [valueConverter]="_uppercaseConverter"
                  [formsControl]="controls().postalCodeCorrespondence"
                  [placeholder]="orderContent().postalCodePlaceholder"
                  [label]="orderContent().postalCodeLabel"
                ></wl-text>
              </div>
              <!-- Huisnummer -->
              <div class="col-6 col-lg-3">
                <wl-number
                  [step]="stepNumber()"
                  [rendering]="rendering()"
                  stepName="leveringsgegevens"
                  fieldName="huisnummer correspondentieadres"
                  [sendValue]="false"
                  [formsControl]="controls().houseNumberCorrespondence"
                  [placeholder]="orderContent().houseNumberPlaceholder"
                  [label]="orderContent().houseNumberLabel"
                ></wl-number>
              </div>
              <!-- Huisnummer additie -->
              @if (!hideCorrespondenceHouseNumberExtensions()) {
                <div class="col-6 col-lg-3">
                  <wl-dropdown
                    [dropdownItems]="correspondenceHouseNumberExtensions()"
                    [formsControl]="
                      controls().houseNumberAdditionCorrespondence
                    "
                    [placeholder]="'Toev.'"
                    stepName="leveringsgegevens"
                    fieldName="toevoeging correspondentieadres"
                  ></wl-dropdown>
                </div>
              }
              @if (orderContent().enableBusinessFields) {
                <div class="col-12">
                  @if (correspondenceAddress(); as correspondenceAddress) {
                    <p class="address-details--success mb-0 mt-1">
                      {{ correspondenceAddress.street }}
                      {{ correspondenceAddress.houseNumber
                      }}{{ correspondenceAddress.houseNumberExtension }},
                      {{ correspondenceAddress.city }}
                    </p>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    }

    <div class="row mb-2">
      <div class="col-12 fw-bold">
        <span class="me-1">{{ orderContent().residenceOrWorkplaceLabel }}</span>
        @if (orderContent().residenceOrWorkplaceTooltip) {
          <wl-tooltip
            [tooltip]="{
              description: orderContent().residenceOrWorkplaceTooltip,
            }"
          ></wl-tooltip>
        }
      </div>
      @if (orderContent().residenceOrWorkplaceText) {
        <div class="col-12">
          <p>{{ orderContent().residenceOrWorkplaceText }}</p>
        </div>
      }
      <wl-radio
        class="col-12"
        [rendering]="rendering()"
        [step]="stepNumber()"
        stepName="leveringsgegevens"
        fieldName="woon of werkadres"
        [formsControl]="controls().residenceOrWorkplace"
        [radioItems]="residenceOrWorkplaceOptions()"
        [inline]="false"
      ></wl-radio>
      @if (controls().residenceOrWorkplace | isInvalid) {
        <wl-input-error
          stepName="leveringsgegevens"
          [step]="stepNumber()"
          wlAutomationId="residence-or-workdate-required-error"
          [messageField]="orderContent().residenceOrWorkplaceRequiredError"
          messageDescription="woon of werkadres"
          [rendering]="rendering()"
        ></wl-input-error>
      }
    </div>

    <wl-order-fulfillment-inswitch-inhouse
      [rendering]="rendering()"
      [formState]="formState()"
      [stepNumber]="stepNumber()"
      [labelsShownAboveFields]="labelsShownAboveFields()"
      (inswitchOpenLegalModal)="inswitchOpenLegalModalClick()"
    />
  </ng-template>
  <ng-template #summary>
    <p class="h6 mb-0">{{ orderContent().supplyAddressTitle }}</p>
    <p>
      <wl-supply-address
        [supplyAddress]="supplyAddress()"
        wlCSMask
      ></wl-supply-address>
    </p>

    @if (orderContent().enableBusinessFields) {
      <p class="h6 mb-0" wlAutomationId="business-fields">
        {{ orderContent().correspondenceAddressTitle }}
      </p>
      @if (formState().value.useAsCorrespondenceAddress) {
        <p>
          <wl-supply-address
            [supplyAddress]="supplyAddress()"
            wlCSMask
          ></wl-supply-address>
        </p>
      }
      @if (!formState().value.useAsCorrespondenceAddress) {
        <p>
          <wl-supply-address
            [supplyAddress]="correspondenceAddress()"
            wlCSMask
          ></wl-supply-address>
        </p>
      }
    }

    <p class="h6 mb-0">{{ orderContent().residenceOrWorkplaceLabel }}</p>
    <p>{{ selectedResidenceOrWorkplaceOption()?.label }}</p>

    <p class="h6 mb-0">{{ orderContent().situationSummaryLabel }}</p>
    <p wlAutomationId="inswitch-inhouse-summary">
      {{ selectedInswitchOrInhouseOptionLabel() }}
    </p>

    <p class="h6 mb-0">{{ orderContent().inswitchLabel }}</p>
    <p>{{ selectedStartDate() | date: 'd MMMM yyyy' }}</p>
  </ng-template>
</wl-simple-progressive-form-card>
